module.exports = __webpack_public_path__ + "static/media/emblemaTAOD2.4f4cf9ce.jpg";